import { declareSlot } from '../../utils/slotsUtils';
import { SlotID } from '../basicSlotIDs';

type ToolsMenuItemSlotProps = {
  text: string;
  onClick: () => void;
};

export const ToolsMenuItemSlot = declareSlot<ToolsMenuItemSlotProps>(
  SlotID.ToolsMenuItem,
);
